const en = {
  "Home": "Home",
  "Add": "Add",
  "Adding": "Adding",
  "Editing": "Editing",
  "Edit": "Edit",
  "Delete": "Delete",
  "Save": "Save",
  "Cancel": "Cancel",
  "Close": "Close",
  "Open": "Open",
  "Users": "Users",
  "Are you sure you want to logout": "Are you sure you want to logout?",
  "Name": "Name",
  "Password": "Password",
  "Email": "Email",
  "Active": "Active",
  "UserIsActive": "User is active",
  "Filter": "Filter",
  "Clear": "Clear",
  "Code": " Code",
  "Actions": "Actions",
  "Confirm Dialog": "Confirm Dialog",
  "User": "User",
  "Are you sure that you want to delete": "Are you sure that you want to delete",
  "Role": "Role",
  "Region": "Region",
  "Administrator": "Administrator",
  "ProductManager": "Product Manager",
  "RegionalManager": "Regional Manager",
  "Trader": "Trader",
  "1000": "User not found",
  "1001": "Email already exist",
  "1002": "Please enter email",
  "1003": "Please enter password",
  "1004": "Please enter name",
  "1005": "Please enter role",
  "1006": "Please enter region",
  "1007": "Please enter current password",
  "1008": "Current password is wrong",
  "Yes": "Yes",
  "No": "No",
  "Login": "Login",
  "Please enter email": "Please enter email.",
  "Please enter Password": "Please enter password.",
  "Invalid E-mail or Password.": "Invalid email or password.",
  "Invalid E-mail.": "Invalid email",
  "Not found E-mail.": "Invalid email or password.",
  "Result": "Results",
  "Logout": "Logout",
  "Products": "Products",
  "Accessories": "Accessories",
  "Offers": "Offers",
  "You are not Authenticated to view this resource": "You are not authorized to view this resource.",
  "RepeatPassword": "Repeat password",
  "Please enter name": "Please enter name.",
  "Please enter password": "Please enter password.",
  "Please repeat password": "Please repeat the password.",
  "Please select a role": "Please select a role.",
  "Please select a region": "Please select a region.",
  "Passwords dont match": "Passwords don't match.",
  "AddUser": "Add user",
  "EditUser": "Edit user",
  "Profile": "Profile",
  "CurrentPassword": "Current password",
  "NewPassword": "New password",
  "Change": "Change",
  "FillCurrentPassword": "Please fill current password",
  "FillNewPassword": "Please fill new password",
  "Password successfully changed": "Password was changed successfully",
  "Change password": "Change password",
  "Regions": "Regions",
  "Configuration": "Configuration",
  "AddRegion": "Add region",
  "EditRegion": "Edit region",
  "RegionIsActive": "Region is active",
  "Categories": "Categories",
  "AddCategory": "Add category",
  "EditCategory": "Edit category",
  "RootCategory": "Root",
  "ChildCategory": "Child",
  "MainCategory": "Main category",
  "SubCategory": "Subcategory",
  "2000": "Please enter region name",
  "2001": "Region not found",
  "2002": "Please enter category name",
  "2003": "Category not found",
  "Add product": "Add product",
  "Edit product": "Edit product",
  "Main info": "Main info",
  "Installation activities": "Installation activities",
  "Fasteners": "Fasteners",
  "Characteristics": "Characteristics",
  "Article number": "Article number",
  "Brand": "Brand",
  "Model": "Model",
  "Category": "Category",
  "Price": "Price (BGN)",
  "Single price": "Single price (BGN)",
  "Discount": "Discount (%)",
  "Description": "Description",
  "There are no installation activities added": "There are no installation activities added.",
  "There are no fasteners added": "There are no fasteners added.",
  "Add installation activity": "Add installation activity",
  "Edit installation activity": "Edit installation activity",
  "Add fastener": "Add fastener",
  "Edit fastener": "Edit fastener",
  "Please add description": "Please add description",
  "Please add price": "Please add price.",
  "Please add article number": "Please add article number.",
  "Please add article name": "Please add article name",
  "Please select category": "Please select category.",
  "Please add brand": "Please add brand.",
  "3000": "Please add brand name",
  "3001": "All instllation activities must have description.",
  "3002": "All fasteners must have description.",
  "3003": "Product not found.",
  "Deactivate": "Deactivate",
  "2004": "Client not found",
  "2005": "Please enter client name",
  "4000": "Offer not found",
  "4001": "Please enter offer date",
  "Status": "Status",
  "OfferNumber": "Offer Number",
  "OfferDate": "Offer Date",
  "TraderName": "Trader Name",
  "ManagerName": "Manager Name",
  "ClientName": "Client Name",
  "City": "City",
  "Address": "Address",
  "BoilerMake": "Boiler Make",
  "New": "New",
  "InProcess": "In Process",
  "Completed": "Completed",
  "TimePeriod": "Time Period",
  "Administration": "Administration",
  "All": "All",
  "Actives": "Аctives",
  "NotActives": "Not actives",
  "3004": "Product with same article number already exists.",
  "Power": "Power",
  "offer": "offer",
  'DateFormat': 'dd/MM/yyyy',
  'Client': 'Client',
  'Total': 'Total (BGN)',
  'Notes': 'Notes',
  'EditOffer': 'Edit Offer',
  'AddOffer': 'Add Offer',
  'Settlement': 'Settlement',
  'Month': 'Month',
  'Quarter': 'Quarter',
  'Year': 'Year',
  "Manager": "Manager",
  "Number": "Number",
  "Date": "Date",
  "Phone": "Phone",
  "Edit user data": "Edit user data",
  "Profile data succesfully saved": "Profile data succesfully saved.",
  "Supplier": "Supplier",
  "Article": "Article",
  "AndAllItsSubcategories": "and all its subcategories",
  "NoRecordsFound": "No records found",
  "NewUser": "New user",
  "NewRegion": "New region",
  "NewCategory": "New category",
  "Articles": "Articles",
  "NewArticle": "New article",
  "EditArticle": "Edit article",
  "UnitNumber": "pcs",
  "UnitLinearMeter": "lm",
  "Unit": "Unit",
  "3005": "Please select a unit.",
  "Please select a unit": "Please select a unit.",
  "Are you sure that you want to delete/deactivate": "Are you sure that you want to delete/deactivate",
  "PriceTo": "Price to (BGN)",
  "Period": "Period",
  'Deleted Successfully': "Deleted Successfully",
  'Data Saved Successfully': "Data Saved Successfully",
  '2006': "Region attached to users. Delete failed!",
  '2007': "Category attached to articles. Delete failed!",
  '1009': "User attached to offers. Delete failed!",
  '3006': "Article attached. Delete failed!",
  '4002': "Offer attached. Delete failed!",
  'ChoosePeriod': 'Choose period',
  'DateFrom': 'Date from',
  'DateTo': 'Date to',
  'CustomPeriod': 'Custom period',
  "Package": "Package",
  "Article search": "Article search...",
  "No records found": "No records found.",
  "Qty": "Qty.",
  "Product is already added": "Article is already added!",
  "No products added to the package": "No products added to the package.",
  "The quantity entered for the related article": "The quantity entered for the related article",
  "is not valid": "is not valid",
  "Articles in package": "Article in package",
  "UnitShort": "Unit",
  "Email address is not valid": "Email address is not valid.",
  "Product price is not valid": "Entered price is not valid.",
  'DateTimeFormat': 'dd/MM/yyyy HH:mm',
  'StartDate': 'Start Date',
  'EndDate': 'End Date',
  'DateFormatUS': 'MM/dd/yyyy',
  'From': 'From',
  'To': 'To',
  'ContractAgreed': 'Contract Agreed',
  'ContractCompleted': 'Contract Completed',
  '1010': "Active regional manager already exists in taht region!",
  'NumberOfActiveUsers': 'Number of active users',
  'NumberOfActiveArticles': 'Number of active articles',
  'NumberOfActiveOffers': 'Number of active offers',
  'NumberOfActiveRegions': 'Number of active regions',
  'NumberOfActiveCategories': 'Number of active categories',
  'NumberOfUsers': 'Number of users',
  'NumberOfArticles': 'Number of articles',
  'NumberOfOffers': 'Number of offers',
  'NumberOfRegions': 'Number of regions',
  'NumberOfCategories': 'Number of categories',
  "from total": "from total",
  'Offer': 'Offer',
  'BillOfQuantities': 'Bill of quantities',
  'AxonometricDiagramGas': 'Axonometric gas diagram',
  'AxonometricDiagramHeat': 'Axonometric heat diagram',
  'Files': 'Files',
  'AllowedFormats': 'Allowed formats',
  'MaxTotalFileSize': 'Max total file size',
  'Download': 'Download',
  'AddFiles': 'Add files',
  'Remove': 'Remove',
  'file': 'file',
  'GasInstallation': 'Gas installation',
  'HeatInstallation': 'Heat installation',
  'Device': 'Device',
  'DevicePackage': 'Device package',
  'Service': 'Service',
  'Equipment': 'Equipment',
  'AncillaryEquipment': 'Ancillary equipment',
  'Type': 'Type',
  '2008': 'File not found',
  'Devices': 'Devices',
  'Services': 'Services',
  'Packages': 'Packages',
  'Materials': 'Materials',
  'type': 'type',
  'Categories without type. Please add type to all categories.': 'Categories without type. Please add type to all categories.',
  'Types': 'Types',
  "CreatedOn": "CreatedOn",
  '4004': "Offer is in progress. Delete failed!",
  "ToPrice": "To price (BGN)",
  "HeatingInstallation": "Heating Installation",
  "Price without VAT": "Price without VAT",
  "Total without VAT": "Total without VAT",
  "Total after discount": "Total after discount",
  "VAT": "VAT",
  "Disctrict": "Disctrict",
  "Total with VAT": "Total with VAT",
  "Radiators": "Radiators",
  'Please select type': 'Please select type',
  '2010': "Region attached to active users. Deactivation failed!",
  "3007": "Cannot get product images",
  "Choose": "Choose",
  "No graphical elements added": "No graphical elements added.",
  "Select graphical element": "Select graphical element",
  "Choose trader": "Choose trader.",
  "Disclaimer": "Disclaimer",
  "cauldron": "gas boiler",
  "radiator": "radiator",
  "kitchen": "kitchen",
  "void": "void",
  "hot-plate": "hot-plate",
  "lyre": "towel rail",
  "smoke-extractor": "smoke-extractor",
  "boiler": "boiler",
  "convector": "convector",
  "default": "default",
  "Price from supplier": "Price from supplier (BGN)",
  "Labor": "Labor",
  "Labor in service": "Labor in service",
  "No labor added in service": "No labor added in service.",
  "without vat": "without VAT",
  "Pipes": "Pipes",
  "Diameter": "Diameter (mm)",
  "Kits": "Kits",
  "Articles in kit": "Articles in kit",
  "Discount amount without VAT": "Discount amount without VAT",
  "Status changes": "Status changes",
  "magnet-ventil": "magnet ventil",
  "triple": "tee",
  "coupling": "coupling",
  "ventil": "ventil",
  "elbow": "elbow",
  "Expired": "Expired",
  "Accepted": "Accepted",
  "InExecution": "In execution",
  "Finished": "Finished",
  "Changed by system": "Changed by system",
  "w/о VAT": "w/о VAT",
  "MaxPrice": "Max Price (BGN)",
  "gasBoiler": "gas boiler",
  "towelRail": "towel rail",
  "tee": "tee",
  "Registered": "Registered",
  "System": "System",
  "Logs": "Logs",
  "View": "View",
  "View last": "View last",
  "No files detected": "No files detected",
  "View current": "View current",
  "No file selected": "No file selected",
  'Can not view directories!': 'Can not view directories!',
  '1011': 'User not authenticated',
  "PriceFromSupplier": "Delivery price (BGN)",
  "Power1": "Power 1",
  "Power2": "Power 2",
  "Recalculate Offer": "Recalculate Offer",
  "Recalculate": "Recalculate",
  "Recalculate dialog": "Recalculation of offer",
  "Change in offer data.": "Change in offer data.",
  "Please contact trader or regional manager": "Please contact trader or regional manager",
  "Please contact trader": "Please contact trader",
  "or his regional manager.": "or regional manager to recalculate offer and offer files.",
  "Cauldrons": "Cauldrons",
  "Stoves": "Stoves",
  "Flues": "Flues",
  "Boilers": "Boilers",
  "TowelRails": "TowelRails",
  "Convectors": "Convectors",
  "steel-radiator": 'steel radiator',
  "Discount (BGN)": "Discount (BGN)",
  "Transfer": "Transfer",
  "TransferOffers": "Transfer Offers",
  'Choose atleast one offer to transfer': 'Choose atleast one offer to transfer.',
  "Save & Close": "Save & Close",
  "Can not trasnfer finished offers!": "Can not trasnfer finished offers!",

  "of": "of",
  "Client information": "Client information",
  "GasInstallPrice": "Gas installation (price without VAT)",
  "HeathInstallPrice": "Heath installation (price without VAT)",
  "BGN": "BGN",
  "Signature": "Signature",
  "Sales Representative": "Sales Representative",
  "Phone for contact": "Phone for contact",
  "Accept the offer": "Accept the offer",
  "Installation": "Installation",
  "Validity of the proposal": "Validity of the proposal",
  "to": "to",
  "Services and materials": "Services and materials",
  "PriceOnly": "Price",
  "ArticleNumber": "Article Number",
  "SentToClient": "Sent"
};

export default en;